var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRussia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagRussia_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagRussia_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagRussia_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagRussia_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagRussia_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-12 44.112h70.482V3H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA0020",
    d: "M-12 44.112h70.482V30.407H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3555E2",
    d: "M-12 30.407h70.482V16.703H-12z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iN2J3aHY4eXJ3YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJyMmdnMnlndWhiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iIzdid2h2OHlyd2EiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiM3Yndodjh5cndhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjcjJnZzJ5Z3VoYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Y0RjRGNCIgZD0iTTAgNDEuMTEyTDcwLjQ4MiA0MS4xMTIgNzAuNDgyIDAgMCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyIDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0VBMDAyMCIgZD0iTTAgNDEuMTEyTDcwLjQ4MiA0MS4xMTIgNzAuNDgyIDI3LjQwNyAwIDI3LjQwN3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMiAzKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMzNTU1RTIiIGQ9Ik0wIDI3LjQwN0w3MC40ODIgMjcuNDA3IDcwLjQ4MiAxMy43MDMgMCAxMy43MDN6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIgMykiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlagRussia as ReactComponent };